import React from "react";
import { Body } from "../Common/Typography";
import {
  BorderWrapper,
  CommentMarkdownContainer,
  CommentWrapper,
} from "./__styles__/Comment";

export interface CommentProps {
  content: string;
  truncate: boolean;
}

const Comment = ({ content, truncate }: CommentProps) => {
  return (
    <CommentWrapper>
      <BorderWrapper truncate={truncate}>
        <Body size="default" type="regular" as="div">
          <CommentMarkdownContainer
            markdown={content}
            truncate={truncate}
            options={{ simpleLineBreaks: true }}
          />
        </Body>
      </BorderWrapper>
    </CommentWrapper>
  );
};

export default Comment;
